import { ComparatorTypes } from './comparator';
import { SortType } from '../components/ColumnHeader';
import { sortParamTypes } from './constants';

export const getComparatorType = (sortParam) => {
    switch (sortParam) {
        case sortParamTypes.SINGLESUTR:
        case sortParamTypes.DOUBLESUTR:
        case sortParamTypes.SINGLESPKB:
        case sortParamTypes.DOUBLESPKB:
        case sortParamTypes.PKBRATING:
        case sortParamTypes.REGDATE:
        case 'regStatus':
        case 'age':
            return ComparatorTypes.NUMBER;
        default:
            return ComparatorTypes.STRING;
    }
};

export const getComparatorArguments = (srtParam, srtType) => {
    const args = [];
    const primarySortArg = {
        type: getComparatorType(srtParam),
        field: 'primarySortValue',
        descend: srtType === SortType.DESC,
    };
    args.push(primarySortArg);
    if (['name', 'wtaOrder', 'utrOrder', 'regStatus'].includes(srtParam)) {
        const seconfarySortArg = {
            type: getComparatorType(srtParam),
            field: 'secondarySortValue',
            descend: srtParam === 'regStatus' ? srtType !== SortType.DESC : srtType === SortType.DESC,
        };
        args.push(seconfarySortArg);
    }
    return args;
};

export const sortObjectsByNameAsc = (a, b) => {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
};

export const sortEventsByStartDateAsc = (a, b) => {
    if (a.eventSchedule?.eventStartUtc && b.eventSchedule?.eventStartUtc) {
        if (a.eventSchedule?.eventStartUtc < b.eventSchedule?.eventStartUtc) {
            return -1;
        }
        if (a.eventSchedule?.eventStartUtc > b.eventSchedule?.eventStartUtc) {
            return 1;
        }
    }
    return 0;
};
